// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Galeria_GenerateMissingThumbnailsResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface Galeria_GenerateMissingThumbnailsResponseDados {
total_images: number
thumbnails_created: number
thumbnails_already_exist: number
errors: number
error_details: string[]
}

export type Galeria_GenerateMissingThumbnailsResponse = ApiResponse<Galeria_GenerateMissingThumbnailsResponseDados>;

registerResponseContract('Galeria_GenerateMissingThumbnailsResponse', {
  total_images:             { type: 'number',  required: true },
  thumbnails_created:       { type: 'number',  required: true },
  thumbnails_already_exist: { type: 'number',  required: true },
  errors:                   { type: 'number',  required: true },
  error_details:            { type: 'array',   required: true },
})
